import React, { useEffect, useState } from "react";
import { EmployeeProfile, truncateToFirstName } from "winslow-core";
import { EmployeeAvatar } from "../common/EmployeeAvatar";
import { apiGetEmployeeProfile } from "../../services/UserService";
import "./SelectedEmployeeCard.css";

export interface SelectedEmployeeCardProps {
  employeeId: string;
  onClick?: (employee: string) => void;
  showCloseButton?: boolean;
  onClose?: () => void;
  onAskAs?: (employeeId: string) => void;
}

export const SelectedEmployeeCard: React.FC<SelectedEmployeeCardProps> = ({
  employeeId,
  onClick,
  showCloseButton,
  onClose,
  onAskAs,
}) => {
  const [employee, setEmployee] = useState<EmployeeProfile | null>(null);

  useEffect(() => {
    (async () => {
      const employee = await apiGetEmployeeProfile(employeeId);
      setEmployee(employee);
    })();
  }, [employeeId]);

  return (
    <div
      className="selected-employee-card"
      onClick={() => onClick?.(employeeId)}>
      {showCloseButton && (
        <div
          className="selected-employee-card-close"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}>
          <img src="/icons/close.png" alt="Remove filter" />
        </div>
      )}
      <div className="selected-employee-card-content">
        {employee && (
          <div className="selected-employee-card-user-info">
            <EmployeeAvatar
              email={employee.email}
              name={employee.displayName}
              avatarUrl={employee?.avatar}
            />
            <div className="selected-employee-card-user-details">
              <div className="selected-employee-card-user-name">
                {employee.displayName}
              </div>
              <div className="selected-employee-card-title">
                {employee.department || ""}
              </div>
            </div>
          </div>
        )}

        {employee && onAskAs && (
          <button
            className="selected-employee-card-ask-button"
            onClick={(e) => {
              e.stopPropagation();
              onAskAs(employeeId);
            }}>
            Ask a Question as{" "}
            <strong>{truncateToFirstName(employee.displayName || "")}</strong>
          </button>
        )}
      </div>
    </div>
  );
};
